import { render, staticRenderFns } from "./Exercise.vue?vue&type=template&id=6e7fcb90&scoped=true&"
import script from "./Exercise.vue?vue&type=script&lang=js&"
export * from "./Exercise.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e7fcb90",
  null
  
)

export default component.exports